import { GraduationCap, RefreshCcw } from "lucide-react";

export const TRACK_META = {
  start: { name: "CareerCompass Start", short: "Start", Icon: GraduationCap, cls: "bg-cyan-100 text-cyan-800" },
  comeback: { name: "CareerCompass Comeback", short: "Comeback", Icon: RefreshCcw, cls: "bg-indigo-100 text-indigo-700" },
};

export const TrackBadge = ({ track }) => {
  const m = TRACK_META[track] || TRACK_META.comeback;
  return (
    <span className={`inline-flex items-center gap-1 font-heading font-bold text-[11px] px-2 py-0.5 rounded-full whitespace-nowrap ${m.cls}`} data-testid={`track-badge-${track || "comeback"}`}>
      <m.Icon className="w-3 h-3" /> {m.short}
    </span>
  );
};

export const TrackSelect = ({ value, onChange, testid }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
    className="mt-1.5 h-10 w-full rounded-xl border border-input bg-white px-3 font-body text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-primary/30">
    <option value="comeback">Comeback — career changers & returners</option>
    <option value="start">Start — students & first careers</option>
  </select>
);
